// Axion Elite — Product Gallery
// Scroll-snap slider + thumbnail sync + variant image scroll.

(function () {
  function init() {
    var gallery   = document.querySelector('.product-gallery-main');
    var thumbs    = document.querySelectorAll('.product-gallery-thumb');
    var slides    = document.querySelectorAll('.product-gallery-slide');

    if (!gallery || !slides.length) return;

    // Scroll the carousel to a slide by index. Every slide is exactly one
    // carousel-width wide (flex: 0 0 100%), so index * clientWidth is the
    // exact scroll offset. The previous implementation used
    // slide.offsetLeft, which is measured from the slide's offsetParent
    // (the page, since the carousel isn't a positioned element) — that
    // extra page-left offset made every click overshoot into the next
    // slide, so clicking the first thumbnail landed on the second image.
    function scrollToIndex(idx) {
      gallery.scrollTo({ left: idx * gallery.clientWidth, behavior: 'smooth' });
      setActive(idx);
    }

    // Sync active thumb when slide scrolls into view
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var idx = parseInt(entry.target.dataset.index, 10);
          setActive(idx);
        }
      });
    }, { root: gallery, threshold: 0.6 });

    slides.forEach(function (slide) { observer.observe(slide); });

    // Thumb click → scroll to slide
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        scrollToIndex(parseInt(thumb.dataset.index, 10));
      });
    });

    function setActive(idx) {
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      if (thumbs[idx]) thumbs[idx].classList.add('is-active');
    }

    // Variant selection → scroll to matching image
    // product-form.js dispatches 'axion:variant-image' with detail { imageId }.
    // Compare as strings: the JSON payload delivers a Number while the DOM
    // dataset is always a String.
    document.addEventListener('axion:variant-image', function (e) {
      var imageId = e.detail && e.detail.imageId;
      if (!imageId) return;
      slides.forEach(function (slide, i) {
        if (String(slide.dataset.imageId) === String(imageId)) {
          scrollToIndex(i);
        }
      });
    });

    // Keep the current slide aligned if the viewport is resized
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var active = document.querySelector('.product-gallery-thumb.is-active');
        var idx = active ? parseInt(active.dataset.index, 10) : 0;
        gallery.scrollTo({ left: idx * gallery.clientWidth });
      }, 150);
    });

    // Init first thumb active
    setActive(0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
